import React from 'react';

import ActionButton from '@core/components/actionbutton/ActionButton';
import IconButton from '@core/components/iconbutton/IconButton';

import AlirezaImage from '@core/assets/images/AlirezaZarei.png';
import LinkedinIcon from '@core/assets/icons/linkedin.png';

import classes from './CareerCoachingBanner.module.scss';
import LinkButton from '@core/components/linkbutton/LinkButton';


const CareerCoachingBanner = () => {
    const handleLinkedinClick = () => {
        window.open('https://www.linkedin.com/in/alireza-zarei/', '_blank');
    };
    return (
        <div className={classes.wrapper}>
            <div className='row'>
                <div className='col-xl-7 col-12 mb-3 mb-xl-0'>
                    <div className={classes.action}>
                        <h3>
                            Personalized Coaching for Your Professional Growth
                        </h3>
                        <p>
                            Get 30-minute expert-led coaching sessions every month with your subscription.
                        </p>

                        <LinkButton to={'/vip-consultation'} kind='primary-color'>
                            Schedule Your Session
                        </LinkButton>
                    </div>
                </div>
                <div className='col-xl-5 col-12 d-flex justify-content-center align-items-center'>
                    <ul>
                        <li>
                            Resume & Cover Letter Review
                        </li>
                        <li>
                            Mock Interviews
                        </li>
                        <li>
                            Career Path Guidance
                        </li>
                        <li>
                            Immigration Advice
                        </li>
                        <li>
                            Job Hunting Tips
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default CareerCoachingBanner;